module.exports = __webpack_public_path__ + "static/process_exporting3_2-1ae9f6b6b6897d3b844f321944d416c3.jpg";